// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1205": "21b273d5eab8","3636": "dbfc89bc969b","8664": "1917b6fc1323",}[chunkId] + ".css"
}